import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {SalesByPaymentTypeReportModel} from "./sales-by-payment-type-report.model";
import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {
    EntityGroupByReportCriteriaComponent
} from "../../../reports/common-report-criteria/entity-group-by-report-criteria/entity-group-by-report-criteria.component";

@Component({
    selector: "wbo-sales-by-payment-type-report",
    templateUrl: "./sales-by-payment-type-report.component.html",
    providers: [provideReportModel(SalesByPaymentTypeReportModel)]
})
export class SalesByPaymentTypeReportComponent extends AbstractReportPage {

    constructor(public model: SalesByPaymentTypeReportModel) {
        super();
    }

    get showOutletOption(): boolean {
        return this.model.data.reportType !== EntityGroupByReportCriteriaComponent.OUTLET_VALUE;
    }
}
